<template>
    <div class="page-customer page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">项目录入管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>项目录入管理</el-breadcrumb-item>
                            <el-breadcrumb-item>项目录入列表</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
				    <el-button type="primary" class="btn-bg-p" @click="handleProject('add')">添加 <i class="el-icon-plus"></i></el-button>
				</el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <!--<el-form-item prop="id" label="ID：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.id" size="small" placeholder="频道ID" clearable></el-input>
                        </el-form-item>-->
                        <el-form-item prop="name" label="维修项目名称：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.projectName" size="small" placeholder="维修项目名称" clearable></el-input>
                        </el-form-item>
                       <el-form-item prop="name" label="维修项目地址：" style="margin-bottom: 0;">
                           <el-input v-model="form_search.address" size="small" placeholder="维修项目地址" clearable></el-input>
                       </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                           
                            <el-table-column prop="projectName" align="center" label="维修项目名称" min-width="120">
                            </el-table-column>
                            <el-table-column prop="description" align="center" label="描述" min-width="160">
                            </el-table-column>
							<el-table-column prop="address" align="center" label="地址" min-width="160">
							</el-table-column>
							
                            <el-table-column prop="operating" align="center" label="操作" min-width="100" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleProject('edit',scope.row)">编辑</el-button>							
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteAppVersion(scope.row.icode)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.pageNo"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
		<el-dialog class="dialog-export goods-dialog" :title="dlg_project.title" :visible.sync="dlg_project.visible" width="600px" @closed="closeGoods" :close-on-click-modal="false">
		    <el-form ref="formProject" :model="dlg_project.form" label-width="120px" :rules="dlg_project.rules" @submit.native.prevent>
		       
				<el-row :gutter="20">
				    <el-col :span="24">
				        <el-form-item prop="projectName" label="项目名称" :error="dlg_project.error.projectName">
				            <el-input size="small"  v-model="dlg_project.form.projectName" clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
				
				<el-row :gutter="20">
				    <el-col :span="24">
				        <el-form-item prop="description" label="描述" :error="dlg_project.error.description">
				            <el-input size="small"  v-model="dlg_project.form.description" clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
				<el-row :gutter="20">
				    <el-col :span="24">
				        <el-form-item prop="address" label="地址" :error="dlg_project.error.address">
				            <el-input size="small"  v-model="dlg_project.form.address" clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
		       
		    </el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dlg_project.visible = false">取 消</el-button>
		        <el-button type="primary" @click="submitProject()" :loading="dlg_project.btn_loading">确认</el-button>
		    </span>
		</el-dialog>
		<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
		    <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
		</el-dialog>
   </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
				
				 baseUrl:this.$client.IMG_URL,
                //搜索
                form_search:{
                    projectName:'',
                   address:'',
                },
               
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        pageNo: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
				dlg_project:{
				    id:'',
				    visible:false,
				    btn_loading:false,
				    api: '',
				    title:'',
				    form:{
						icode:'',
				        projectName:'',
						
						description:'',
						address:'',
						createdate:'',
						updatedate:''
				    },
				    error:{
				        projectName:'',
						
						description:'',
						address:''
						
						
				    },
				    reset_form: {},
				    rules:{
				        projectName:{required: true, message: '请输入维修项目名称', trigger: ['change','blur']},
				       
						description:{required: true, message: '请输入描述', trigger: ['change','blur']},
						address:{required: true, message: '请输入地址', trigger: ['change','blur']},
						
				        
				    },
				},
				
				appVersion:{
					params: {
						headers: {
							token: localStorage.getItem('token')
						},
						data:{
							file:''
						},
						
						
					},
					hide_upload:false,
					img_list:[]
				},
				dlg_preview:{
				    visible: false,
				    img_url: ''
				}
				
            }
        },
        created() {
            document.title = '维修项目管理';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
			
			// apk上传成功
			uploadSuccessApk(res, file, fileList){
			    this.appVersion.img_list = fileList;
			    this.dlg_project.form.fileId = res.data.icode;
				console.log(res.data,"数据")
			    this.dlg_project.hide_upload = true;
			},
			// 删除apk
			removeApk(file, fileList){
			    this.dlg_project.form.fileId = '';
			    this.appVersion.img_list = [];
			    this.appVersion.hide_upload = false;
			},
			//关闭编辑或新政
			 closeGoods(){
				for(var key in this.dlg_project.form){
					this.dlg_project.form[key] = this.dlg_project.reset_form[key];
				}
				this.appVersion.img_list=[]
				this.$nextTick(()=>{
					this.$refs.formProject.clearValidate();
			})
			},
			//编辑或新增
			handleProject(type,data){
			    this.dlg_project.visible = true;
			    if(type == 'add'){
			        this.dlg_project.title = '添加维修项目录入';
			        this.dlg_project.api = '/api/sys/maintenanceProject/create';
			    }else{
			        this.dlg_project.id= data.icode;
			        this.dlg_project.title = '编辑维修项目录入';
			        if(data){
			            for(var key in this.dlg_project.form){
			                this.dlg_project.form[key] = data[key];
			            }
						// 主图
						// if(data.fileId){
						// 	this.appVersion.img_list = [{url: this.baseUrl + data.fileId}];
						// 	this.appVersion.hide_upload = true;
						// }else{
						// 	this.appVersion.img_list = [];
						// 	this.appVersion.hide_upload = false;
						// }
					}
					this.dlg_project.api = '/api/sys/maintenanceProject/update';
			    }
			},
			//提交维修项目信息
			submitProject(){
			    var _this = this;
			    _this.$refs['formProject'].validate((valid) => {
			        if (valid) {
			            this.dlg_project.btn_loading = true;
			            this.$client.post(this.dlg_project.api, this.dlg_project.form, function(res,message){
			                //console.log(res)
			                _this.$message(message);
			                _this.getList();
			                _this.dlg_project.btn_loading = false;
			                _this.dlg_project.visible = false;
			            }, function(message){
			                _this.dlg_project.btn_loading = false;
			                if((typeof message)==='object'){
			                    for(var key in message){
			                        _this.dlg_project.error[key] = message[key];
			                    }
			                }
			            });
			        } else {
			            console.log('error submit!!');
			    return false;
			}
			});
			},
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.pageNo = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                // var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/api/sys/maintenanceProject/getList', params, function(res,message,total,totalPages){
					// console.log("热水",res,total)
                    _this.table_data.list = res;
                    _this.table_data.page_info.total = total;
					 // _this.table_data.page_info.total = total;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
			//删除维修项目
			deleteAppVersion(id){
			    var _this = this;
			    this.$confirm('确定要删除？', "", {
			                confirmButtonText: "确定",
			                cancelButtonText: "取消",
			                iconClass:"icon-delete el-icon-delete",
			                customClass:"my-confirm-box",
			                center: true,
			            })
			            .then(() => {
			        _this.$client.post('/api/sys/maintenanceProject/remove', {id:id}, function(res,message){
			        _this.getList();
			    },function(res){
			
			    });
			})
			.catch(() => {});
			},
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>

</style>
<style scoped >
.hide-upload .el-upload--picture-card {
        display: none;
    }
</style>